import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Switch, Route, Redirect} from 'react-router-dom';
import {SurveyViewPageState} from '../state';
import {AdminContainer} from './admin';
import {SummaryContainer} from './summary';

const SurveyViewPage = observer(({uiState}) => {
  const {match, scope, survey} = uiState;

  return (
    <Switch>
      {scope.overview && <Route path={`${match.path}/admin`}
        render={({match, history}) => <AdminContainer {...{match, history, scope, survey}} />} />}
      {scope.summary && <Route path={`${match.path}/summary`}
        render={({match, history}) => <SummaryContainer {...{match, history, scope, survey}} />} />}
      <Redirect exact from={match.path} to={`${match.path}/summary`} />
    </Switch>
  );
});

export default withState(SurveyViewPage, SurveyViewPageState);
